import { useMemo } from "react";
import { AuditoinnitCacheKeys } from "../cacheKeys";
import { IAuditItem } from "../../interfaces/IAuditItem";
import { useSWROffline } from "../../../sg-core/swr/useSWROffline";
import { useSWRCache } from "../../../sg-core/swr/useSWRCache";
import { useAuthContext } from "../../auth/AuthenticationProvider";

export type IUseAuditItemHook = (auditId: IAuditItem["id"]) => {
    data: IAuditItem | null;
    fetching: boolean;
}

export const useAuditItem: IUseAuditItemHook = (auditId) => {
    const { cache } = useSWRCache();
    const { token, lang } = useAuthContext();

    const fetcher = async (): Promise<IAuditItem | null> => {

        const key = AuditoinnitCacheKeys(token, lang).AuditItemInstance(auditId);
        return cache.get(key);

        // return null
    };

    const cacheKey = AuditoinnitCacheKeys(token, lang).AuditItemInstance(auditId);
    const { data, isValidating } = useSWROffline(
        cacheKey,
        fetcher,
        {
            suspense: true,
            initialData: null,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            revalidateOnMount: false,
            refreshWhenOffline: false,
            refreshWhenHidden: false,

        }
    );

    const rawData = data ?? null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating,
    }), [rawData, isValidating]);
};
